
import React, { Component } from 'react';
import RealSolutions from './RealSolutions'
import noBridgeDeepGradient from '../../img/no-bridge-deep-gradient.png'
import onlyBridge from '../../img/only-bridge.png'
import './Bridge.css'



class Bridge extends Component {

  render() {

    return (
      <section ref="trigger" id="bridge-section" className="bridge-section" >

        <div className="container-fluid" >

          <h1 className="hard-data-heading">The Hard Data:</h1>

          <div className="row">
            <div id="bridge-content" className="bridge-content centered">
              <h4>To Get Out of Last Place<sup>TM</sup></h4>
              <h4>Mississippi Needs</h4>
              <h2>$4.8B More Income</h2>
            </div>
          </div>

        </div>

        <div className="bridge-background" >
          <img src={onlyBridge} style={this.props.bridge}  className="only-bridge" alt="bridge" />
          <img src={noBridgeDeepGradient} className="no-bridge" alt="no bridge" />
          <RealSolutions balloon={this.props.balloon} />
        </div>

      </section>
    );
  }
}

export default Bridge;



/** WEBPACK FOOTER **
 ** ./src/components/home/Bridge.js
 **/